import React from 'react'
import loading from "../images/loading.gif"

function Spinner() {
    return (
        <div className="text-center">
            <img src={loading} alt="loading"  />
        </div>
    )
}

export default Spinner
